// Inventory Module - Root Reducers
// This file aggregates all inventory-related reducers

// Categories
import InventoryCategoriesListReducer from './Categories/List/store/slice'
import InventoryCategoriesFormReducer from './Categories/Form/store/slice'

// Types
import InventoryTypesListReducer from './Types/List/store/slice'
import InventoryTypesFormReducer from './Types/Form/store/slice'

// Products
import InventoryProductsListReducer from './Products/List/store/slice'
import InventoryProductsFormReducer from './Products/Form/store/slice'
import InventoryProductsDetailsReducer from './Products/Details/store/slice'

// Combine all inventory reducers
const inventoryReducers = {
  ...InventoryCategoriesListReducer,
  ...InventoryCategoriesFormReducer,
  ...InventoryTypesListReducer,
  ...InventoryTypesFormReducer,
  ...InventoryProductsListReducer,
  ...InventoryProductsFormReducer,
  ...InventoryProductsDetailsReducer,
}

export default inventoryReducers

